import { render, staticRenderFns } from "./Graduacao.vue?vue&type=template&id=ffea00b0"
import script from "./Graduacao.vue?vue&type=script&lang=js"
export * from "./Graduacao.vue?vue&type=script&lang=js"
import style0 from "./Graduacao.vue?vue&type=style&index=0&id=ffea00b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports